export default __webpack_public_path__ + "static/media/agustin18.edefa381.png";